import { InjectProperty } from '@jack-henry/frontend-utils/di';
import { NavigationService } from '@treasury/core/navigation';
import { TmBaseComponent } from '@treasury/presentation';
import '@treasury/presentation/components/tm-combo-box';
import Fuse from 'fuse.js';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { FeatureSearchService } from '../services/feature-search.service';

export const tagName = 'feature-search';
@customElement(tagName)
export class FeatureSearch extends TmBaseComponent {
    @InjectProperty()
    declare public featureSearchService: FeatureSearchService;

    @InjectProperty()
    declare public navService: NavigationService;

    @state()
    public items: Array<{ label: string; value: { route: string } }> = [];

    public async firstUpdated() {
        await this.featureSearchService.getNavigationItems();
        this.items = this.featureSearchService.filteredNavigationItems;
    }

    protected render() {
        return html`
            <div class="flex-row-reverse flex w-full">
                <tm-combo-box
                    class="w-[500px] m-2"
                    .placeholder=${'What would you like to do?'}
                    .helperText=${'Search for features or actions'}
                    .items=${this.items}
                    .filterFunction=${(
                        items: Array<{ label: string; value: { route: string } }>,
                        searchTerm: string
                    ) => {
                        if (!searchTerm) {
                            return [];
                        }
                        const fuse = new Fuse(items, {
                            keys: ['label'],
                            includeScore: true,
                            shouldSort: true,
                        });
                        const results = fuse.search(searchTerm);
                        return results.map(result => result.item);
                    }}
                    @value-changed=${(e: CustomEvent) => {
                        if (!e.detail) {
                            return;
                        }
                        const selectedItem = e.detail;
                        this.navService.navigate(selectedItem.route);
                    }}
                ></tm-combo-box>
            </div>
        `;
    }
}
